import React from 'react';
import {
  PromptGroup,
  PromptItemKind,
  PromptDocuments,
} from 'types/candidateStories';
import FilePromptItem from './FilePromptItem/Container';

const CandidateStoryPromptFileForm = ({
  promptGroup,
  disabled,
  promptDocuments,
  remove,
  recordId,
}: {
  promptGroup: PromptGroup | null;
  disabled: boolean;
  promptDocuments: PromptDocuments;
  remove: (index: number, field: string) => void;
  recordId?: string;
}) => {
  if (disabled || !promptGroup || promptGroup.items.length === 0) {
    return null;
  }

  const fileItems = promptGroup.items.filter(
    item => item.kind === PromptItemKind.FILE,
  );

  if (fileItems.length === 0) {
    return null;
  }

  return (
    <div data-testid='candidate-story-prompt-file-form'>
      {fileItems.map(item => (
        <FilePromptItem
          key={item.id}
          item={item}
          promptDocuments={promptDocuments}
          remove={remove}
          recordId={recordId}
        />
      ))}
    </div>
  );
};

export default CandidateStoryPromptFileForm;
